import { Input } from "../../ui/input";

export const InputField = ({ label, value, onChange, disabled, className, labelClassName = "", containerClassName = "", readOnly = false }) => (
  <div className={`flex flex-col ${containerClassName}`}>
    <label className={`block text-sm mb-1 ${labelClassName}`}>{label}</label>
    <Input
      value={value}
      onChange={onChange ? (e) => onChange(e.target.value) : undefined}
      disabled={disabled}
      className={`${className} ${readOnly ? 'bg-gray-50 cursor-default focus:outline-none focus:ring-0 pointer-events-none' : ''}`}
      readOnly={readOnly}
    />
  </div>
);